<section class="globalSettingHeader__ccontainer">
  <div class="globalSettingHeader__heading">Global Settings</div>
  <div class="globalSettingHeader__subHeading">
    Configure and setup based on your organisation preferences
  </div>
</section>